import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { LexiconDetail, lexiconDetailHead } from "@/components/LexiconDetail";
import { LexiconPage, ENTRIES } from "@/components/LexiconPage";
import { resolvePilotId, pilotSlug } from "@/lib/lexicon-pilot";

/** Every glossary concept has a detail page; pilots additionally resolve English slugs. */
function resolveConceptId(slug: string): string | null {
  const pilot = resolvePilotId(slug);
  if (pilot) return pilot;
  const s = decodeURIComponent(slug).trim().toLowerCase();
  return ENTRIES.some((e) => e.id === s) ? s : null;
}

export const Route = createFileRoute("/sozluk/$slug")({
  beforeLoad: ({ params }) => {
    const id = resolveConceptId(params.slug);
    if (!id) throw redirect({ to: "/sozluk", replace: true });
    // EN slug girilirse TR slug'una yönlendir (canonical TR)
    if (id !== params.slug) {
      throw redirect({ to: "/sozluk/$slug", params: { slug: id }, replace: true });
    }
  },
  loader: ({ params }) => {
    const id = resolveConceptId(params.slug);
    if (!id) throw notFound();
    return { id };
  },
  head: ({ loaderData }) =>
    loaderData
      ? lexiconDetailHead({
          id: loaderData.id,
          lang: "tr",
          trSlug: loaderData.id,
          enSlug: pilotSlug(loaderData.id, "en"),
        })
      : { meta: [{ title: "Sözlük" }] },
  errorComponent: () => <LexiconPage lang="tr" />,
  notFoundComponent: () => <LexiconPage lang="tr" />,
  component: () => {
    const { id } = Route.useLoaderData();
    return <LexiconDetail id={id} lang="tr" />;
  },
});
